export function normalizeLivekitUrl(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) {
    return '';
  }

  const hasScheme = /^[a-z][a-z0-9+\-.]*:\/\//i.test(trimmed);
  const candidate = hasScheme ? trimmed : `ws://${trimmed}`;

  try {
    const parsed = new URL(candidate, typeof window !== 'undefined' ? window.location.origin : undefined);
    switch (parsed.protocol) {
      case 'http:':
        parsed.protocol = 'ws:';
        break;
      case 'https:':
        parsed.protocol = 'wss:';
        break;
      case 'ws:':
      case 'wss:':
        break;
      default:
        parsed.protocol = 'ws:';
        break;
    }
    return parsed.toString();
  } catch (error) {
    console.error('Invalid LiveKit URL configuration', error);
    return '';
  }
}
